// extracted by mini-css-extract-plugin
export default {"cancelSearchButton":"SongSearchControlResetButton_cancelSearchButton__43SQS"};